import React from 'react'
import { string } from 'prop-types'
import { useDispatch } from 'react-redux'
import classnames from 'classnames/bind'

import { actions as appActions } from '../../store/app'
import { actions as resultActions } from '../../store/result'

import styles from './index.module.css'

const cx = classnames.bind(styles)

export default function NavButton(props) {
  const { to, status } = props
  const dispatch = useDispatch()

  const handleClick = () => {
    if (to === 'pretest') {
      dispatch(appActions.createTest())
      // dispatch(appActions.changeStage(2))
      // dispatch(resultActions.fetchAdData())
    } else {
      dispatch(appActions.changeStage(2))
      dispatch(resultActions.fetchAdData())
    }
  }
  return (
    <div
      className={cx('navBtn', { hide: status === 'hide' })}
      onClick={handleClick}
    >
      {to === 'pretest' ? '跳过预热环节，直接开始测试' : '差不多了，查看结果'}
    </div>
  )
}

NavButton.propTypes = {
  to: string,
  status: string
}
